import React from 'react';
import { Icon } from '../../design/Icon';

export function Card({ title, description, actions, footer, flush = false, loading = false, className = '', bodyClassName = '', children, ...rest }) {
  const hasHead = title || description || actions;
  return (
    <section className={['card', loading ? 'is-loading' : '', className].filter(Boolean).join(' ')} aria-busy={loading || undefined} {...rest}>
      {hasHead && (
        <div className="card-head">
          <div>
            {title && <div className="t">{title}</div>}
            {description && <div className="d">{description}</div>}
          </div>
          {actions && <div className="acts">{actions}</div>}
        </div>
      )}
      <div className={['card-body', flush ? 'flush' : '', bodyClassName].filter(Boolean).join(' ')}>{children}</div>
      {footer && <div className="card-foot">{footer}</div>}
    </section>
  );
}

export function Panel({ className = '', children, ...rest }) {
  return (
    <div className={`panel ${className}`.trim()} {...rest}>
      {children}
    </div>
  );
}

const DELTA_ICON = { 'up-good': 'arrowUp', 'up-bad': 'arrowUp', 'down-good': 'arrowDown', 'down-bad': 'arrowDown', flat: 'arrowRight' };

export function Delta({ direction = 'flat', children }) {
  return (
    <span className={`delta ${direction}`}>
      <Icon name={DELTA_ICON[direction] || 'arrowRight'} className="ico-sm" />
      {children}
    </span>
  );
}

export function KpiLedger({ loading = false, className = '', children }) {
  return (
    <div className={['kpis', loading ? 'is-loading' : '', className].filter(Boolean).join(' ')} aria-busy={loading || undefined}>
      {children}
    </div>
  );
}

export function Kpi({ label, value, unit, spark, meta, icon }) {
  const valueNode = (
    <div className="k-value num">
      {value}
      {unit && <small>{unit}</small>}
    </div>
  );
  return (
    <div className="kpi">
      <div className="k-label">
        {icon && <Icon name={icon} className="ico-sm" />}
        {label}
      </div>
      {spark ? (
        <div className="k-row">
          {valueNode}
          <div className="k-spark">{spark}</div>
        </div>
      ) : (
        valueNode
      )}
      {meta && <div className="k-meta">{meta}</div>}
    </div>
  );
}
